export default __webpack_public_path__ + "static/jdavinson-da6300a659bab3b205535d45ee6f3cdc.jpg";